CategoryPicker = { // TODO: Перенести на vue
    data: {},
    languages: {
        "ru": [
            {id: 'ru', 'name': 'Русский язык', icon: null},
            {id: 'en', 'name': 'Английский язык', icon: null},
        ],
        "en": [
            {id: 'ru', 'name': 'Russian language', icon: null},
            {id: 'en', 'name': 'English language', icon: null},
        ],
    },
    selected: {'language':null,'categories':[]},
    locale: null,
    currentLevel: 1,
    activeItem: false,
    init: function (categoriesPicker, defaultChecked,language) {

        this.data = categoriesPicker;
        _.map(this.data, (items) => {
            _.map(items, (item) => {
                CategoryPicker._defaultValue(item, (typeof defaultChecked !== 'undefined'?defaultChecked:false));
            });
        });
        this.locale = language||$('html').attr('lang');
        this.selected.language = this.locale;
        document.querySelector('.js-open-categoryPicker-language').setAttribute('data-locale', this.locale)
        this.events();
    },
    _defaultValue: function (item, value) {
        if(value === null){
            item.checked = item.checked||item.default||false;
        }else {
            item.checked = value||item.default;
        }
        if (item.hasOwnProperty('children')) {
            _.map(item.children, (item) => {
                CategoryPicker._defaultValue(item, value);
            });
        }
    },
    openCategories: function (e) {
        this.currentLevel = 1;
        this.activeItem = false;
        this.render();
        $('.js-categoryPicker-categories').toggle();
        $('.search-picker-languages').hide();
    },
    openLanguage: function (e) {
        this.currentLevel = 3;
        this.activeItem = false;
        this.render();
        $('.js-categoryPicker-categories').hide();
        $('.search-picker-languages').toggle();
    },
    check: function (){
        var values = [];
        var findNotChecked = false;
        CategoryPicker.selected.language = this.locale;
        CategoryPicker.selected.category = [];
        _.map(CategoryPicker.data[this.locale], (item) => {
            if (item.checked || item.children.length) {
                let pickAll = false;
                if (_.filter(item.children, {'checked': true}).length === item.children.length) {
                    pickAll = true;
                    values.push(item.name);
                    CategoryPicker.selected.category.push(item.id);
                }
                _.map(item.children, (children) => {
                    if (children.checked) {
                        CategoryPicker.selected.category.push(children.id);
                        if (!pickAll) {
                            values.push(children.name);
                            findNotChecked = true;
                        }
                    }
                });
            } else if (item.checked) {
                CategoryPicker.selected.category.push(item.id);
                values.push(item.name);
            }
        });
        return [findNotChecked, values];
    },
    scrollBack: function (){
        if($(window).width()>=768){
            return;
        }
        var block = $('.js-open-categoryPicker-category');
        if($(window).scrollTop()>(block.offset().top+block.height())){
            $('html, body').animate({
                scrollTop: block.offset().top-100
            }, 600);
        }
    },
    apply: function (e){
        var values = [];
        var findNotChecked = false;
        [findNotChecked, values] = this.check();
        if(this.currentLevel == 2 && $('.search-picker-items').hasClass('search-picker-item-active') &&
            this.activeItem !== false &&
            !_.filter(this.data[this.locale][this.activeItem].children, {'checked': true}).length){
            _.map(this.data[this.locale][this.activeItem].children, (item) => {
                CategoryPicker._defaultValue(item, true);
            });
            [findNotChecked, values] = this.check();
        }
        if(!values.length && !$('.search-picker-items').hasClass('search-picker-item-active')){
            $('.search-picker-items').addClass('search-picker-item-active');
        }else if(!findNotChecked && !_.filter(this.data[this.locale], {'checked': false}).length){
            values = [lang.picker[this.locale].all];
        }
        $('.js-open-categoryPicker-category').text(function (){
            if(values.length){
                return _.join(values, ', ');
            }
            return $(this).parent().attr('data-default-text');
        });
        $('.js-open-categoryPicker-language').text(function(){
            if(CategoryPicker.selected.language){
                return _.find(CategoryPicker.languages[CategoryPicker.locale],{'id':CategoryPicker.selected.language}).name;
            }
            return $(this).parent().attr('data-default-text');
        });
        document.querySelector('.js-open-categoryPicker-language').setAttribute('data-locale', this.locale)
        if(this.currentLevel == 3){
            $('.js-categoryPicker-languages').hide();
        }else{
            $('.js-categoryPicker-categories').hide();
        }
        this.scrollBack();
    },
    search: function (e){
        location.href = '/'+$('html').attr('lang')+'/search?'+$.param(this.selected);
    },
    clear: function (e){
        this.activeItem = false;
        this.locale = $('html').attr('lang');
        _.map(this.data, (items) => {
            _.map(items, (item) => {
                CategoryPicker._defaultValue(item, false);
            });
        });
        $('.js-open-categoryPicker-category').text(()=>{
            this.apply(e);
        });
        this.render();
    },
    render: function () {
        _.map(this.data[this.locale], (items) => {
            if (items.children.length) {
                if (_.filter(items.children, {'checked': true}).length) {
                    items.checked = true;
                } else {
                    items.checked = false;
                }
            }
        });
        if (this.currentLevel === 1) {
            this.renderLevel1();
        } else if (this.currentLevel === 2) {
            this.renderLevel2();
        } else if (this.currentLevel === 3) {
            this.renderLanguages(this.languages[this.locale]);
        }
    },
    events: function () {
        $('.js-open-categoryPicker-search').click((e) => {
            this.search(e);
            return false;
        });
        $('.js-open-categoryPicker-category').click((e) => {
            this.openCategories(e);
            return false;
        });
        $('.js-open-categoryPicker-language').click((e) => {
            this.openLanguage(e);
            return false;
        });
        $('.js-apply-categoryPicker').click((e) => {
            this.apply(e);
            return false;
        });
        $('.js-clear-categoryPicker').click((e) => {
            this.clear(e);
            return false;
        });
        $('.search-picker-items').click((e) => {
            var new_value = true;
            if (e.currentTarget.classList.contains('search-picker-item-active')) {
                new_value = false;
                e.currentTarget.classList.remove('search-picker-item-active');
            } else {
                e.currentTarget.classList.add('search-picker-item-active');
            }
            if (this.activeItem === false) {
                _.map(this.data[this.locale], (item) => {
                    CategoryPicker._defaultValue(item, new_value);
                });
            } else {
                _.map(this.data[this.locale][this.activeItem].children, (item) => {
                    CategoryPicker._defaultValue(item, new_value);
                });
            }
            this.render();
            return false;
        });
        window.onclick = (e) => {
            if(!$(e.currentTarget).closest('search-picker').length){
               this._closeDropdowns(e);
            }
        }
    },
    _closeDropdowns: function (e){
        $('.search-picker-categories').hide();
        $('.search-picker-languages').hide();
    },
    _back: function (e) {
        this.currentLevel = 1;
        this.activeItem = false;
        this.render();
    },
    _clickItem: function (e, item) {
        let isParent = item.hasOwnProperty('children') && item.children.length,
            childrenChecked = false;
        if (e.target.classList.contains('check') || !isParent) {
            $(e.currentTarget).toggleClass('search-picker-item-active');
            if ((item.checked = !item.checked)) {
                $(e.currentTarget).addClass('search-picker-item-active');
                childrenChecked = true;
            } else {
                $(e.currentTarget).removeClass('search-picker-item-active');
            }
            if (isParent) {
                _.map(item.children, (item) => {
                    CategoryPicker._defaultValue(item, childrenChecked);
                });
            } else if (this.activeItem !== false) {
                if (_.filter(this.data[this.locale][this.activeItem].children, {'checked': true}).length) {
                    this.data[this.locale][this.activeItem].checked = true;
                } else {
                    this.data[this.locale][this.activeItem].checked = false;
                }
            }
            this.renderAllBtn();
        } else if (isParent) {
            this.currentLevel = 2;
            this.activeItem = _.findIndex(this.data[this.locale], {'id': item.id});
            this.renderLevel2(item.children);
        }
    },
    _itemView: function (v) {
        return $('<li>').addClass('search-picker-item')
            .addClass('with-svg')
            .addClass('search-picker-' + v.id)
            .addClass(function () {
                if (v.checked) {
                    return 'search-picker-item-active';
                }
            })
            .append(
                $('<a>')
                    .attr('href', '#')
                    .append('<span class="search-picker-svg">'+(v.icon?'<img src="/storage/'+v.icon+'" />':'')+'</span><span class="search-picker-name">' + v.name + '</span><span class="check"></span>')

            ).click((e) => {
                CategoryPicker._clickItem(e, v);
                return false;
            })
    },
    _languageItemView: function (v) {
        return $('<li>').addClass('search-picker-item')
            .addClass('with-svg')
            .addClass('search-picker-' + v.id)
            .addClass(function () {
                if (v.id === CategoryPicker.selected.language) {
                    return 'search-picker-item-active';
                }
            })
            .append(
                $('<a>')
                    .attr('href', '#')
                    .append('<span class="search-picker-svg"><svg><use xlink:href="/assets/images/sprite.svg#flag_'+v.id+'"></use></svg></span><span class="search-picker-name">' + v.name + '</span><span class="check"></span>')

            ).click((e) => {
                if(this.locale){
                    $('.search-picker-'+this.locale).removeClass('search-picker-item-active');
                }
                $('.search-picker-'+v.id).addClass('search-picker-item-active');
                if(this.locale != v.id){
                    swal({
                        text: lang.picker[v.id].alert_change_lang,
                        icon: 'warning'
                    }).then(function () {
                    });
                    this.locale = v.id;
                    this.apply(e);
                }else{
                    this.locale = v.id;
                }
                return false;
            })
    },
    _subItemView: function (v) {
        return $('<li>').addClass('search-picker-item')
            .addClass('search-picker-' + v.id)
            .addClass(function () {
                if (v.checked) {
                    return 'search-picker-item-active';
                }
            })
            .append(
                $('<a>')
                    .attr('href', '#')
                    .append('<span class="search-picker-name">- ' + v.name + '</span><span class="check"></span>')
            )
            .click((e) => {
                CategoryPicker._clickItem(e, v);
                return false;
            })
    },
    renderAllBtn: function (items) {
        if (typeof items === 'undefined') {
            if (this.activeItem === false) {
                items = this.data[this.locale];
            } else {
                items = this.data[this.locale][this.activeItem].children;
            }
        }
        /*if (_.filter(items, {'checked': false}).length) {
            $('.search-picker-items').removeClass('search-picker-item-active');
        } else {
            $('.search-picker-items').addClass('search-picker-item-active');
        }*/
    },
    renderLevel: function (level, items) {
        let links = [];
        if (level === 2) {
            items = items || this.data[this.locale][this.activeItem].children;
            links.push($('<li>').addClass('search-picker-item')
                .addClass('search-picker-item-back')
                .append('<a href="#"><span>'+lang.picker[this.locale].back+'</span></a>').click((e) => {
                    this._back(e);
                    return false;
                })
            );
        } else {
            items = this.data[this.locale];
        }
        $('.search-picker-items span:first-child').text(lang.picker[this.locale].all);
        this.renderAllBtn(items);
        _.each(items, function (v, k) {
            links.push(level === 2 ? CategoryPicker._subItemView(v) : CategoryPicker._itemView(v));
        });
        $('.js-categoryPicker-categories .search-picker-list').html('');
        _.each(_.chunk(links, 6), function (group, k) {
            $('.js-categoryPicker-categories .search-picker-list').append($('<ul>').append(group));
        });
    },
    renderLevel1: function () {
        return this.renderLevel(1);
    },
    renderLevel2: function (items) {
        return this.renderLevel(2, items);
    },
    renderLanguages: function (items) {
        let links = [];
        _.each(items, function (v, k) {
            links.push(CategoryPicker._languageItemView(v));
        });
        $('.js-categoryPicker-languages .search-picker-list').html('').append($('<ul>').addClass('w-100').append(links));
    },
};
